import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  getPanoramasRequest: [],
  getPanoramasFailure: [],
  getPanoramasSuccess: ['data', 'total'],
  setPanoramasSort: ['sort', 'direction'],
  setPanoramasPage: ['page', 'limit'],
  resetPanoramasData: [],
  setPanoramasSearch: ['value'],
  getPanoramasAllDepartmentsRequest: [],
  getPanoramasAllDepartmentsSuccess: ['data'],
  getPanoramasAllDepartmentsFailure: [],
  setPanoramasPropertyFilter: ['property', 'value'],
})

const INITIAL_STATE = {
  options: {
    sort: 'created_at',
    direction: 'desc',
    search: '',
    page: 0,
    total: 0,
    limit: 20,
    filters: [
      { name: 'department_id', value: null },
    ],
  },
  data: [],
  circularData: null,
  loading: false,
  dataFunctions: [],
  departments: {
    data: [],
    loading: false,
  },
  allDepartments: {
    data: [],
    loading: false,
  },
}

const getPanoramasRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const getPanoramasFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const getPanoramasSuccess = (state = INITIAL_STATE, { data, total }) => ({
  ...state,
  options: {
    ...state.options,
    total,
  },
  data,
  loading: false,
})

const setPanoramasSort = (state = INITIAL_STATE, { sort, direction }) => ({
  ...state,
  options: {
    ...state.options,
    sort,
    direction,
    page: 0,
  },
})

const setPanoramasPage = (state = INITIAL_STATE, { page, limit }) => ({
  ...state,
  options: {
    ...state.options,
    page,
    limit,
  },
})

const resetPanoramasData = (state = INITIAL_STATE) => ({
  ...state,
  circularData: null,
  loading: false,
})

const setPanoramasSearch = (state = INITIAL_STATE, { value }) => ({
  ...state,
  options: {
    ...state.options,
    search: value,
    page: 0,
  },
})

const getPanoramasAllDepartmentsRequest = (state = INITIAL_STATE) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    loading: true,
  },
})

const getPanoramasAllDepartmentsSuccess = (
  state = INITIAL_STATE,
  { data },
) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    data,
    loading: false,
  },
})

const getPanoramasAllDepartmentsFailure = (state = INITIAL_STATE) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    loading: false,
  },
})

const setPanoramasPropertyFilter = (state = INITIAL_STATE, { property, value }) => {
  return {
    ...state,
    options: {
      ...state.options,
      filters: state.options.filters.map((filter) => {
        if (filter.name === property) {
          return {
            ...filter,
            value,
          }
        }
        return filter
      }),
    },
  }
}

export default createReducer(INITIAL_STATE, {
  [Types.GET_PANORAMAS_REQUEST]: getPanoramasRequest,
  [Types.GET_PANORAMAS_FAILURE]: getPanoramasFailure,
  [Types.GET_PANORAMAS_SUCCESS]: getPanoramasSuccess,
  [Types.SET_PANORAMAS_SORT]: setPanoramasSort,
  [Types.SET_PANORAMAS_PAGE]: setPanoramasPage,
  [Types.RESET_PANORAMAS_DATA]: resetPanoramasData,
  [Types.SET_PANORAMAS_SEARCH]: setPanoramasSearch,
  [Types.GET_PANORAMAS_ALL_DEPARTMENTS_REQUEST]: getPanoramasAllDepartmentsRequest,
  [Types.GET_PANORAMAS_ALL_DEPARTMENTS_SUCCESS]: getPanoramasAllDepartmentsSuccess,
  [Types.GET_PANORAMAS_ALL_DEPARTMENTS_FAILURE]: getPanoramasAllDepartmentsFailure,
  [Types.SET_PANORAMAS_PROPERTY_FILTER]: setPanoramasPropertyFilter,
})
